module.exports = __webpack_public_path__ + "img/w3_circle_pause_light.8191acbc.png";